import { auth } from '../firebase';
import {
    RecaptchaVerifier,
    signInWithPhoneNumber,
    signOut as firebaseSignOut,
} from 'firebase/auth';
import { PHONE } from '../constants';

export const signIn = async (data, type) => {
    if (type === PHONE) {
        try {
            const appVerifier = new RecaptchaVerifier(auth, 'recaptcha-container', { size: 'invisible' });
            const confirmResult = await signInWithPhoneNumber(auth, data.number, appVerifier);
            return confirmResult;
        } catch (error) {
            throw error;
        }
    }
};

export const confirmOtp = async (otp, confirmResult) => {
    try {
        const result = await confirmResult.confirm(otp);
        return result;
    } catch (error) {
        throw error;
    }
};

export const getCurrentUser = () => auth.currentUser;

export const signOut = async () => {
    try {
        await firebaseSignOut(auth);
    } catch (error) {
        console.log(error);
        throw error;
    }
};